// extracted by mini-css-extract-plugin
module.exports = {"partners":"Providers_partners__6jdSH","providerCount":"Providers_providerCount__qp2XZ"};